import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    last_order_confirmation: null,
    lastOrderData: {}
  },
  actions,
  mutations
}
